import httpClient from '@/lib/httpClient'
// import { handleFormError } from '@/utils/helpers'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { toast } from 'sonner'

export default function useVerifyEmailWithTargetUrl({
  target,
}: {
  target: string
}) {
  // const queryClient = useQueryClient()

  const action = async () => {
    await httpClient.get('/csrf-cookie')

    const response = await httpClient.get(``, {
      baseURL: target,
    })
    return response
  }

  const mutation = useMutation({
    mutationFn: action,
    onSuccess: (res, variables) => {
      toast.success('Confirmed.')
    },
    // onError: (error, variables) =>
    //   handleFormError({
    //     error,
    //     variables,
    //     setError,
    //     clientServerFieldMapping,
    //   }),
  })

  return {
    action: mutation.mutateAsync,
    status: mutation,
  }
}
